import { makeStyles, tokens } from '@fluentui/react-components';

// Shared surface/layout styles for the changeV2 prototype. Token-based so the
// module tracks the app's custom brand theme; Tailwind handles one-off layout.
export const useChangeV2Styles = makeStyles({
  page: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    backgroundColor: tokens.colorNeutralBackground3,
  },
  contentColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    maxWidth: '1360px',
    margin: '0 auto',
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalXXXL,
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
  },
  surface: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingHorizontalL,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow2,
  },
  sectionHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
  },
  muted: {
    color: tokens.colorNeutralForeground3,
  },
  fieldGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: tokens.spacingHorizontalL,
    '@media (max-width: 900px)': {
      gridTemplateColumns: '1fr',
    },
  },
  formColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    maxWidth: '640px',
  },
});
